module.exports = {
  "age": {
    en: " yo",
    fi: "v",
  },
  "gender-1": {
    en: "Male",
    fi: "Mies",
  },
  "gender-2": {
    en: "Female",
    fi: "Nainen",
  },
  "gender-3": {
    en: "Other",
    fi: "Muu",
  },

  "reset": {
    en: "Reset",
    fi: "Aloita alusta",
  },

  "begin": {
    en: "Start by selecting your electoral district",
    fi: "Aloita valitsemalla vaalipiirisi",
  },
  "start": {
    en: "Start",
    fi: "Aloita",
  },

  vero: {
    en: "Raising taxes vs savings from public sector",
    fi: "Veronkorotukset vai julkisten menojen leikkaukset",
  },
  ymparisto: {
    en: "Environment vs economic growth",
    fi: "Ympäristö vai talouskasvu",
  },
  eu: {
    en: "Decision making power of the EU",
    fi: "EU:n päätösvalta",
  },
  monikulttuuri: {
    en: "Multiculturalism",
    fi: "Monikulttuurisuus",
  },
  420: {
    en: "Legalise cannabis",
    fi: "Kannabis lailliseksi",
  },
  ahvenanmaa: {
    en: "The demilitarisation of Åland should be abandoned",
    fi: "Ahvenanmaan demilitarisoinnista luovuttava",
  },
  lande: {
    en: "Remote areas can have fewer public services",
    fi: "Syrjäseuduilla voi olla vähemmän julkisia palveluja",
  },

  "Ei": {
    en: "No",
    fi: "Ei",
  },
  "Kyllä": {
    en: "Yes",
    fi: "Kyllä",
  },
  "Veronkorotukset": {
    en: "Raising taxes",
  },
  "Leikkaukset": {
    en: "Savings",
  },
  "Ympäristö": {
    en: "Environment",
  },
  "Talouskasvu": {
    en: "Economic growth",
  },

  "skip": {
    en: "Not relevant for me / I'm not sure",
    fi: "Ei väliä / En tiedä",
  },
  "most important": {
    en: "What's most important topic for you?",
    fi: "Mikä on tärkein aihe sinulle?"
  },

  "show more": {
    en: "Show more",
    fi: "Näytä lisää",
  },
  "show more parties": {
    en: "Show more parties",
    fi: "Näytä lisää puolueita",
  },
  "Filter results": {
    en: "Filter candidates",
    fi: "Rajaa ehdokkaita",
  },
  "Age": {
    fi: "Ikä",
  },
  "Gender": {
    fi: "Sukupuoli",
  },
  "Party": {
    fi: "Puolue",
  },
  "partyAlliance": {
    en: "Electoral alliance",
    fi: "Vaaliliitto",
  },
  "current": {
    en: "Current",
    fi: "Nykyinen",
  },
  "europarlamentaarikko": {
    en: "MEP",
    fi: "europarlamentaarikko",
  },
  "1 matching candidate": {
    fi: "1 sopiva ehdokas",
  },
  "matching": {
    fi: "sopivaa",
  },
  "1 best matching candidate": {
    fi: "1 eniten sopiva ehdokas",
  },
  "best matching": {
    fi: "eniten sopivaa",
  },
  "other": {
    fi: "muuta",
  },
  "candidates": {
    fi: "ehdokasta",
  },
  "Different opinion": {
    fi: "Eroava mielipide",
  },
  "resultshelp": {
    en: "Results are ordered based on both the candidates' and party's suitability.",
    fi: 'Tulokset on järjestetty sekä ehdokkaan että puolueen sopivuuden mukaan.',
  },
  "noopinions": {
    en: "No results, all candidates are shown.",
    fi: 'Ei vastauksia, näytetään kaikki ehdokkaat.',
  },

  "info0": {
    en: "Pikavaalikone (quick election compass) is a tool for finding your candidate in the 2023 Finnish parliamentary elections. Find your candidate by answering only 7 questions.",
    fi: "Pikavaalikone on nopea vaalikone eduskuntavaaleihin 2023, jonka voit tehdä alle minuutissa. Vastaa vain 7 kysymykseen ja löydä itsellesi nopeasti sopiva ehdokas.",
  },
  "info1": {
    en: "",
    // fi: "Ennakkoäänestys on 22.–28.3 (ulkomailla 22.–25.3). Vaalipäivä on 2.4.",
    fi: "",
  },
  "footerInfo": {
    en: "The answers are given by the candidate or averages from other election compass answers. In the results you'll get candidates that match your opinions. The results are sorted by your most important topic and the parties' average answers. You can filter the candidates based on age, gender or party.",
    fi: "Pikavaalikoneen vastaukset ovat ehdokkaiden omia vastauksia tai keskiarvoja muiden vaalikoneiden vastauksista. Tuloksissa näet samoin vastanneet ehdokkaat järjestettynä valitsemasi painoarvon sekä puolueiden vastausten keskiarvon mukaisessa järjestyksessä. Voit suodattaa ehdokkaita iän, sukupuolen sekä puolueen mukaan.",
  },
  "instructions": {
    en: "Instructions for voting",
    fi: "Ohjeet äänestämiseen.",
  },
  "instructionsUrl": {
    en: "https://vaalit.fi/en/for-voters",
    fi: "https://vaalit.fi/aanestajalle",
  },
  "station": {
    en: "Find your polling station.",
    fi: "Löydä äänestyspaikka kartalta.",
  },
  "stationUrl": {
    en: "https://www.aanestyspaikat.fi/",
    fi: "https://www.aanestyspaikat.fi/",
  },
  // Eduskuntavaaleissa Pikavaalikonetta käytti yli 35000 äänestäjää jotka vastasivat keskimäärin 41 sekunnissa
  //

  "about": {
    en: "Pikavaalikone was made to be the easiest way to select an election candidate.",
    fi: "Pikavaalikone ",
  },

  "contact": {
    en: 'Contact',
    fi: 'Ota yhteyttä',
  },

  "or": {
    en: 'or',
    fi: 'tai',
  },

  "back": {
    en: '< previous',
    fi: '< edellinen',
  },
  "change": {
    en: '< change answers',
    fi: '< muuta vastauksia',
  },

  "privacy": {
    en: "This site collects anonymous information on visitor counts and answers. All data is handled inside the EU and it can't be traced to you. If you don't want to give information,",
    fi: 'Sivu kerää anonyymisti tietoa sivun käynneistä ja vastauksista. Tietoja käsitellään vain EU:n alueella eikä niitä voida yhdistää sinuun. Jos et halua antaa tietoja,',
  },
  "clickhere": {
    en: 'click here',
    fi: 'paina tästä',
  },

  "Search": {
    fi: 'Hae',
  },

  "search county": {
    en: 'Find your county',
    fi: 'Hae kuntasi'
  },

  "Loading...": {
    fi: 'Ladataan...',
  },

  // candidateApp
  "candidateinfo0": {
    en: "Pikavaalikone (quick election compass) is a fast tool for finding your candidate with only 7 questions. More than 10000 voters have used it in this election.",
    fi: "Pikavaalikone on 7 kysymyksen nopea vaalikone, jonka voi tehdä alle minuutissa. Näissä vaaleissa pikavaalikonetta on käyttänyt jo yli 10 000 äänestäjää.",
  },
  "candidateinfo1": {
    en: "You can give your answers below. Pikavaalikone also uses anwswers from other election compasses.",
    fi: "Voit antaa omat vastauksesi tällä sivulla. Vaalikone hyödyntää myös muiden vaalikoneiden vastauksia.",
  },
  "candidate most important": {
    en: "What are the most important topics for you? (Max 3)",
    fi: "Mitkä ovat tärkeimpiä aiheita sinulle? (Max 3)"
  },
  "are you": {
    en: 'Are you candidate number',
    fi: 'Oletko ehdokas numero',
  },
  "thank you": {
    en: 'Thank you for answering!',
    fi: 'Kiitos vastaamisesta! Tulosten päivittymisessä menee hetki.',
  },
  "done": {
    en: 'Done',
    fi: 'Valmis',
  },
}